import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaicabservice() {



const cardData = {
  keyword: " Mumbai Cab Service",

headingDescription:
  "Omshree Cab offers dependable and comfortable Mumbai cab service for travelers who need reliable transportation within the city or to nearby destinations. Whether you’re heading to the airport, doing city sightseeing, attending business meetings, planning family outings, or booking outstation trips, our service ensures safe and smooth travel with professional drivers and well‑maintained vehicles. We provide flexible booking options including one‑way rides, round trips, hourly rentals, full‑day packages, and long‑distance travel plans at transparent and affordable pricing. Our fleet includes air‑conditioned sedans, spacious SUVs, luxury cars, multi‑purpose vehicles (MPVs), and tempo travelers suitable for solo travelers, families, groups, and corporate clients. With experienced chauffeurs familiar with Mumbai’s roads and pickup points, punctual service, and 24/7 customer support, Omshree Cab is your trusted partner for all your cab needs in Mumbai.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of Mumbai’s most iconic landmarks, located along the Arabian Sea in South Mumbai. Built during the British era, this majestic arch attracts tourists for photography, sightseeing, and ferry rides to Elephanta Island. The surrounding Colaba area also has buzzing cafes, heritage buildings, and street markets. A cab service makes it easy and comfortable to reach this famous location from anywhere in the city without worrying about traffic or parking."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal road along the Arabian Sea, popularly known as the Queen’s Necklace because of the lights that sparkle at night. Visitors enjoy evening walks, sunset views, and photography along this iconic stretch. A reliable cab service allows travelers to explore Marine Drive and nearby attractions comfortably at their own pace."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most popular beaches where families, friends, and tourists come to enjoy the sea breeze, sandy shores, and delicious street food like pav bhaji, bhel puri, and pani puri. The beach becomes especially lively at sunset. Booking a cab makes getting here from any part of the city simple and stress‑free."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a revered Hindu temple dedicated to Lord Ganesha and one of the most visited spiritual sites in Mumbai. Devotees and tourists come here to offer prayers, experience the spiritual ambience, and admire its architecture. A cab ride ensures convenient travel to this temple while avoiding parking issues and busy city traffic."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "Bandra Worli Sea Link is a modern architectural marvel that connects Bandra and Worli across the Arabian Sea. The cable‑stayed bridge offers breathtaking views of the city skyline and sea, especially at sunset and nighttime when it’s illuminated. A cab service ensures a smooth and scenic drive across this iconic landmark, enhancing your Mumbai travel experience."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous religious and cultural landmark located on a small island off the coast of Mumbai. The white marble structure stands beautifully in the sea and is connected to the mainland by a narrow walkway at low tide. Visitors from various backgrounds come here to pray and enjoy the peaceful surroundings. Taking a cab makes traveling to this unique spot convenient and comfortable."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock‑cut caves located on Elephanta Island in Mumbai Harbour, known for their intricate carvings and sculptures dedicated to Lord Shiva. The site is recognized as a UNESCO World Heritage Site and attracts history and culture enthusiasts. A cab service helps you reach the ferry departure point at Gateway of India, making your excursion to the caves seamless."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a vast green forest reserve within Mumbai, offering trekking, nature walks, wildlife viewing, and the historic Kanheri Caves. Visitors enjoy a refreshing escape from city life amidst lush surroundings. Using a cab service makes it easy to reach this natural attraction and explore the park comfortably."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a lively shopping street in South Mumbai filled with stalls selling clothing, accessories, handicrafts, and souvenirs. The area also has numerous cafes and restaurants offering local and international cuisine. Taking a cab ensures convenient and comfortable travel to this busy marketplace and neighboring attractions."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also known as Pherozeshah Mehta Gardens, are beautifully landscaped terraces on Malabar Hill offering panoramic views of Marine Drive and the Arabian Sea. Visitors come here to relax, take photographs, and enjoy peaceful walks amidst greenery. A cab service provides a convenient way to reach this scenic spot and include it in a full day of city sightseeing."
  }
],



services: [
{
name: "Mumbai Cab Service",
description: "Mumbai cab service provides convenient and reliable transportation across the city and nearby destinations. Professional drivers offer punctual pickup and safe driving services from homes, offices, hotels, railway stations, and airport terminals. Vehicles are well maintained and suitable for city travel, airport transfers, and intercity journeys. Ideal for business travelers, tourists, and families. Air-conditioned vehicles ensure comfortable journeys even during long rides. Flexible booking options allow passengers to reserve cabs easily anytime."
},
{
name: "Cab Service Mumbai",
description: "Cab service in Mumbai offers dependable transportation for travelers moving across different parts of the city. The service includes well-maintained vehicles suitable for local travel, airport transfers, and long-distance journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup is available from homes, offices, hotels, railway stations, and airport terminals. Ideal for daily commuting, tourism visits, and corporate travel. Comfortable vehicles ensure smooth journeys for passengers. Flexible booking options allow convenient ride reservations."
},
{
name: "Taxi Service Mumbai",
description: "Taxi service in Mumbai provides comfortable and reliable travel for passengers across the city and nearby destinations. Vehicles are suitable for both short city rides and longer intercity journeys. Professional drivers ensure punctual pickup and safe driving services throughout Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airports. Ideal for business travel, tourism visits, and daily commuting. Air-conditioned vehicles ensure comfortable travel experiences. Flexible booking options allow quick taxi reservations."
},
{
name: "Mumbai Taxi Service",
description: "Mumbai taxi service offers reliable transportation across all major areas of the city. Travelers can book comfortable vehicles for local rides, airport transfers, and outstation journeys. Professional drivers ensure safe driving and timely pickups from homes, hotels, offices, railway stations, and airports. Ideal for tourists, families, and corporate travelers. Spacious seating ensures comfortable travel experiences. Flexible booking options allow passengers to reserve taxis easily."
},
{
name: "Cab Booking Mumbai",
description: "Cab booking in Mumbai allows passengers to quickly reserve taxis for city travel and outstation journeys. Online and phone booking options provide instant confirmation and convenient ride scheduling. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, family trips, and tourism visits. Comfortable vehicles ensure relaxed journeys. Flexible booking options allow easy ride reservations."
},
{
name: "Taxi Booking Mumbai",
description: "Taxi booking in Mumbai provides convenient ride reservations for passengers traveling across the city or to nearby destinations. Booking services offer quick confirmation and reliable transportation options. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for airport transfers, city rides, and business trips. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow convenient travel planning."
},
{
name: "Cheap Cab Service Mumbai",
description: "Cheap cab service in Mumbai offers affordable transportation for travelers seeking economical travel options. Budget-friendly vehicles provide comfortable seating and reliable city transportation. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airports. Ideal for students, tourists, and daily commuters. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow economical travel planning."
},
{
name: "Best Cab Service Mumbai",
description: "Best cab service in Mumbai provides professional transportation with well-maintained vehicles and experienced drivers. The service focuses on safety, punctuality, and customer satisfaction. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, tourism visits, and family trips. Comfortable vehicles ensure smooth travel experiences across the city. Professional drivers ensure reliable service throughout the journey. Flexible booking options allow easy ride reservations."
},
{
name: "Airport Cab Service Mumbai",
description: "Airport cab service in Mumbai provides convenient transportation to and from airport terminals across the city. Vehicles offer comfortable seating and luggage space suitable for travelers with baggage. Professional drivers track flight schedules to ensure timely pickup and drop services. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for business travelers, tourists, and family airport transfers. Air-conditioned vehicles ensure comfortable travel experiences. Flexible booking options allow advance reservations."
},
{
name: "Local Cab Service Mumbai",
description: "Local cab service in Mumbai provides reliable transportation for passengers traveling within city limits. Vehicles are suitable for short rides, shopping trips, office travel, and daily commuting. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for local travel, sightseeing, and daily transportation needs. Comfortable interiors ensure smooth journeys. Flexible booking options allow convenient ride reservations."
},
{
name: "Outstation Cab Service Mumbai",
description: "Outstation cab service in Mumbai offers comfortable transportation for travelers planning trips outside the city. Vehicles are suitable for highway travel and long-distance journeys to nearby cities and tourist destinations. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for weekend trips, pilgrimage travel, and family vacations. Spacious vehicles ensure comfortable journeys. Flexible booking options allow convenient travel planning."
},
{
name: "Mumbai Cab Booking Online",
description: "Mumbai cab booking online allows travelers to reserve taxis easily through digital platforms. Online booking systems provide instant confirmations and convenient ride scheduling. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for business travelers, tourists, and families. Comfortable vehicles ensure relaxed journeys. Flexible booking options allow easy travel planning."
},
{
name: "24x7 Cab Service Mumbai",
description: "24x7 cab service in Mumbai provides round-the-clock transportation for passengers traveling at any time of the day or night. Vehicles are available for airport transfers, emergency travel, and late-night rides. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for travelers needing reliable transportation anytime. Comfortable vehicles ensure safe journeys. Flexible booking options allow convenient travel anytime."
},
{
name: "Reliable Taxi Service Mumbai",
description: "Reliable taxi service in Mumbai provides dependable transportation for passengers seeking safe and punctual travel across the city. The service includes experienced drivers and well-maintained vehicles. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, tourism visits, and daily commuting. Comfortable vehicles ensure smooth journeys across the city. Professional drivers ensure consistent and reliable service. Flexible booking options allow convenient ride reservations."
},
{
name: "Corporate Cab Service Mumbai",
description: "Corporate cab service in Mumbai provides professional transportation for business executives and company employees. Vehicles offer comfortable seating suitable for office transfers, meetings, and airport pickups. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from offices, hotels, airports, and corporate hubs. Ideal for corporate meetings, conferences, and executive travel. Comfortable vehicles ensure relaxed journeys for professionals. Flexible booking options allow scheduled corporate transportation."
},
{
name: "Luxury Cab Service Mumbai",
description: "Luxury cab service in Mumbai provides premium transportation for travelers seeking stylish and comfortable travel experiences. Luxury vehicles offer spacious seating, elegant interiors, and smooth driving performance. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for VIP travel, weddings, and corporate executives. Premium interiors ensure relaxing travel experiences. Flexible booking options allow convenient luxury ride reservations."
}
],

tableData: [
["Mumbai Cab Service","Cab Service Mumbai"],
["Taxi Service Mumbai","Mumbai Taxi Service"],
["Cab Booking Mumbai","Taxi Booking Mumbai"],
["Cheap Cab Service Mumbai","Best Cab Service Mumbai"],
["Airport Cab Service Mumbai","Local Cab Service Mumbai"],
["Outstation Cab Service Mumbai","Mumbai Cab Booking Online"],
["24x7 Cab Service Mumbai","Reliable Taxi Service Mumbai"],
["Corporate Cab Service Mumbai","Luxury Cab Service Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced City Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in navigating Mumbai’s busy roads, highways, and major routes. They know the fastest paths across areas like Andheri, Bandra, Borivali, Thane, and Navi Mumbai, ensuring safe and timely travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs provides clear and transparent pricing for cab services in Mumbai. Customers receive complete fare details including per-kilometer rates and travel packages before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Service",
    WhyChoosedescription: "Our Mumbai cab service operates 24 hours a day. Whether you need an early morning airport drop, late-night pickup, or city travel during the day, we provide reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, regularly cleaned, and fully air-conditioned to ensure passengers enjoy a comfortable and relaxing ride."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Options",
    WhyChoosedescription: "Customers can book cabs for local travel within Mumbai or outstation trips to popular destinations like Pune, Lonavala, Nashik, Shirdi, Surat, and Mahabaleshwar."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers suitable for families and group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your journey begins smoothly and on time."
  },
  {
    WhyChooseheading: "Trusted Taxi Service in Mumbai",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for reliable cab services in Mumbai. Our punctual drivers, comfortable vehicles, and professional service ensure a smooth and stress-free journey."
  }
]
};

const faqData = [
  { question: "Do you provide cab service in Mumbai?", answer: "Yes, Omshree Cabs provides reliable cab services in Mumbai for local travel, airport transfers, and outstation trips." },
  { question: "Is cab service available 24 hours in Mumbai?", answer: "Yes, our cab booking service operates 24/7 for passenger convenience." },
  { question: "Which vehicles are available for booking?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on passenger requirements." },
  { question: "Do you provide airport pickup and drop services?", answer: "Yes, we provide cab services for Mumbai Airport pickup and drop." },
  { question: "Can I book a cab for outstation travel?", answer: "Yes, we provide outstation cab services from Mumbai to destinations like Pune, Nashik, Shirdi, Surat, and many other cities." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned." },
  { question: "Can I book a cab online?", answer: "Yes, customers can easily book a cab online or by phone for quick confirmation." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended during weekends, holidays, and peak travel seasons." },
  { question: "Do you provide corporate cab services?", answer: "Yes, we provide corporate transportation services for business travel and employee transport." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain hygiene and passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Shah",
    feedback:
      "Very reliable cab service in Mumbai. The driver arrived on time and the car was clean and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Mehta",
    feedback:
      "Excellent Mumbai cab service. Smooth booking process, professional driver, and great travel experience.",
    rating: 5
  }
];












































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Cab Service",
  "description": "Omshree Cab provides reliable cab services in Mumbai, including local rides, airport transfers, outstation trips, corporate travel, and luxury cab options. Enjoy comfortable, safe, and punctual rides with flexible booking options and well-maintained vehicles for all your travel needs in Mumbai.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2300"
  }
};







  return (
    <div>
      

<Helmet>
  <title>Mumbai Cab Service | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers cab services in Mumbai including local rides, airport transfers, outstation trips, corporate and luxury travel. Safe, comfortable, and punctual rides with flexible booking options and well-maintained vehicles." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/60.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaicabservice;